module.exports = __webpack_public_path__ + "static/media/10.48a493ef.JPG";